import React, { useRef } from 'react'

// redux
import { connect } from "react-redux";

// bootstrap
import { Spinner } from "react-bootstrap";

// icons
import { BiLock, BiCheck } from "react-icons/bi";

// payment methods
// import StripePayment from '../StripePayment';
import PaymentForm from '../CustomPayment/PaymentForm';

function OptionCreditCard(props) {
    // props
    const {
        currentUser,

        formik,

        handleShippingMethodChange,

        paymentMethodsImages,

        handleCountryChange,
        handleStateChange,

        countries,
        states,
        cities,

        allCheckoutDetails,

        btnDisabled,

        sectionLoading,

        stripeToken,
        setStripeToken,

        handleAddressesModalOpen,
        chooseShippingAddress
    } = props

    // refs
    const submitBtnRef = useRef(null)

    return (
        <div className="content-view mb-3">
            <div className="cv-inner">
                <div className="head-container mb-3">
                    <p className="head mb-1 st-fs-25">Payment information</p>
                </div>

                <div className="form-content position-relative step2">
                    <form
                        onSubmit={formik.handleSubmit}
                        noValidate
                        autoComplete="off">
                        {
                            // billing address
                            !formik.values.billingAddressSameAsShippingAddress ? (
                                <div className="billing-address">
                                    <div className="head-container mb-3">
                                        <p className="head mb-1 st-fs-25">Billing address</p>
                                        <p className="desc mb-0">All fields are required.</p>
                                    </div>

                                    <div className="form-content position-relative">
                                        <div className="d-flex flex-wrap">
                                            <div className="form-lt">
                                                <label className="mb-1">First Name <span className="st-fs-12">(required)</span></label>
                                                <input
                                                    type="text"
                                                    placeholder="First Name"
                                                    id="firstName"
                                                    {...formik.getFieldProps('firstName')}
                                                />
                                                {
                                                    (formik.touched.firstName && formik.errors.firstName) ? (
                                                        <div className="error-msg st-fs-12 text-danger position-absolute">
                                                            {formik.errors.firstName}
                                                        </div>
                                                    ) : null
                                                }
                                            </div>

                                            <div className="form-rt">
                                                <label className="mb-1">Last Name <span className="st-fs-12">(required)</span></label>
                                                <input
                                                    type="text"
                                                    placeholder="Last Name"
                                                    id="lastName"
                                                    {...formik.getFieldProps('lastName')}
                                                />
                                                {
                                                    (formik.touched.lastName && formik.errors.lastName) ? (
                                                        <div className="error-msg st-fs-12 text-danger position-absolute">
                                                            {formik.errors.lastName}
                                                        </div>
                                                    ) : null
                                                }
                                            </div>

                                            <div className="form-ct">
                                                <label className="mb-1">Company Name</label>
                                                <input
                                                    type="text"
                                                    placeholder="Company Name"
                                                    id="companyName"
                                                    {...formik.getFieldProps('companyName')}
                                                />
                                                {
                                                    (formik.touched.companyName && formik.errors.companyName) ? (
                                                        <div className="error-msg st-fs-12 text-danger position-absolute">
                                                            {formik.errors.companyName}
                                                        </div>
                                                    ) : null
                                                }
                                            </div>

                                            <div className="form-ct">
                                                <label className="mb-1">Country <span className="st-fs-12">(required)</span></label>
                                                <select
                                                    id="country"
                                                    {...formik.getFieldProps('country')}
                                                    onChange={ev => {
                                                        formik.handleChange(ev)
                                                        handleCountryChange(ev)
                                                    }}
                                                >
                                                    <option disabled value="choose">Please choose</option>
                                                    {
                                                        countries?.length ? countries.map(item => (
                                                            <React.Fragment key={item.country_id}>
                                                                <option value={item.country_id}>{item.country}</option>
                                                            </React.Fragment>
                                                        )) : null
                                                    }
                                                </select>
                                                {
                                                    (formik.touched.country && formik.errors.country) ? (
                                                        <div className="error-msg st-fs-12 text-danger position-absolute">
                                                            {formik.errors.country}
                                                        </div>
                                                    ) : null
                                                }
                                            </div>

                                            <div className="form-lt">
                                                <label className="mb-1">State <span className="st-fs-12">(required)</span></label>
                                                <select
                                                    id="state"
                                                    // className={(formik?.values?.country?.length === 0) ? "disabled" : ""}
                                                    // disabled={(formik?.values?.country?.length === 0)}
                                                    {...formik.getFieldProps('state')}
                                                    onChange={ev => {
                                                        formik.handleChange(ev)
                                                        handleStateChange(ev)
                                                    }}
                                                >
                                                    <option disabled value="">Please choose</option>
                                                    {
                                                        states?.length ? states.map(item => (
                                                            <React.Fragment key={item.region_id}>
                                                                <option value={item.region_id}>{item.region}</option>
                                                            </React.Fragment>
                                                        )) : null
                                                    }
                                                </select>
                                                {
                                                    (formik.touched.state && formik.errors.state) ? (
                                                        <div className="error-msg st-fs-12 text-danger position-absolute">
                                                            {formik.errors.state}
                                                        </div>
                                                    ) : null
                                                }
                                            </div>

                                            <div className="form-rt">
                                                <label className="mb-1">City <span className="st-fs-12">(required)</span></label>
                                                <select
                                                    id="city"
                                                    // className={((formik?.values?.country?.length === 0) || (formik?.values?.state?.length === 0)) ? "disabled" : ""}
                                                    // disabled={((formik?.values?.country?.length === 0) || (formik?.values?.state?.length === 0))}
                                                    className={((formik?.values?.state?.length === 0)) ? "disabled" : ""}
                                                    disabled={((formik?.values?.state?.length === 0))}
                                                    {...formik.getFieldProps('city')}
                                                >
                                                    <option disabled value="">Please choose</option>
                                                    {
                                                        cities?.length ? cities.map(item => (
                                                            <React.Fragment key={item.city_id}>
                                                                <option value={item.city_id}>{item.city}</option>
                                                            </React.Fragment>
                                                        )) : null
                                                    }
                                                </select>
                                                {
                                                    (formik.touched.city && formik.errors.city) ? (
                                                        <div className="error-msg st-fs-12 text-danger position-absolute">
                                                            {formik.errors.city}
                                                        </div>
                                                    ) : null
                                                }
                                            </div>

                                            <div className="form-ct">
                                                <label className="mb-1">Address <span className="st-fs-12">(required)</span></label>
                                                <input
                                                    type="text"
                                                    placeholder="Address"
                                                    id="address"
                                                    {...formik.getFieldProps('address')}
                                                />
                                                {
                                                    (formik.touched.address && formik.errors.address) ? (
                                                        <div className="error-msg st-fs-12 text-danger position-absolute">
                                                            {formik.errors.address}
                                                        </div>
                                                    ) : null
                                                }
                                            </div>

                                            <div className="form-ct">
                                                <label className="mb-1">Address 2 <span className="st-fs-12">(required)</span></label>
                                                <input
                                                    type="text"
                                                    placeholder="Address 2"
                                                    id="address1"
                                                    {...formik.getFieldProps('address1')}
                                                />
                                                {
                                                    (formik.touched.address1 && formik.errors.address1) ? (
                                                        <div className="error-msg st-fs-12 text-danger position-absolute">
                                                            {formik.errors.address1}
                                                        </div>
                                                    ) : null
                                                }
                                            </div>

                                            <div className="form-lt">
                                                <label className="mb-1">Zip Code <span className="st-fs-12">(required)</span></label>
                                                <input
                                                    type="text"
                                                    placeholder="Zip Code"
                                                    id="zipCode"
                                                    {...formik.getFieldProps('zipCode')}
                                                />
                                                {
                                                    (formik.touched.zipCode && formik.errors.zipCode) ? (
                                                        <div className="error-msg st-fs-12 text-danger position-absolute">
                                                            {formik.errors.zipCode}
                                                        </div>
                                                    ) : null
                                                }
                                            </div>

                                            <div className="form-rt">
                                                <label className="mb-1">Phone <span className="st-fs-12">(required)</span></label>
                                                <input
                                                    type="number"
                                                    placeholder="Phone"
                                                    id="phone"
                                                    {...formik.getFieldProps('phone')}
                                                />
                                                {
                                                    (formik.touched.phone && formik.errors.phone) ? (
                                                        <div className="error-msg st-fs-12 text-danger position-absolute">
                                                            {formik.errors.phone}
                                                        </div>
                                                    ) : null
                                                }
                                            </div>

                                            <div className="form-ct">
                                                <label className="st-default-checkbox d-inline-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="d-none mb-0"
                                                        checked={formik.getFieldProps('isDefault').value}
                                                        {...formik.getFieldProps('isDefault')}
                                                    />
                                                    <span className="checkbox d-flex align-items-center justify-content-center">
                                                        <BiCheck />
                                                    </span>
                                                    <span className="text ps-2">
                                                        Set as Default
                                                    </span>
                                                </label>
                                            </div>

                                            {/* btns */}
                                            <div className="others w-100">
                                                <p
                                                    className="different st-fs-13 cursor-pointer d-inline-flex text-white"
                                                    onClick={() => formik.setFieldValue("billingAddressSameAsShippingAddress", true)}
                                                    style={{ background: "#333", padding: "2px 7px", borderRadius: 5 }}>
                                                    Use shipping address
                                                </p>
                                                {
                                                    currentUser ? (
                                                        <p
                                                            className="different st-fs-13 cursor-pointer d-inline-flex text-white ms-2 ms-lg-3"
                                                            onClick={handleAddressesModalOpen}
                                                            style={{ background: "#333", padding: "2px 7px", borderRadius: 5 }}>
                                                            {/* Use your default billing address */}
                                                            Choose different addresses
                                                        </p>
                                                    ) : null
                                                }
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            ) : (
                                // address display
                                <div className="credit-card-address-details">
                                    <p className="head st-fs-16 st-fw-600 mb-1">Billing address (same as shipping address)</p>
                                    <p className="name mb-1 st-fw-600">
                                        {(allCheckoutDetails?.shippingAddressDetails?.shipping_first_name ?? "") + " " + (allCheckoutDetails?.shippingAddressDetails?.shipping_last_name ?? "")}
                                    </p>
                                    <p className="address mb-2">
                                        {(allCheckoutDetails?.shippingAddressDetails?.addressToShow ?? "")}
                                    </p>
                                    <p
                                        className="different st-fs-13 cursor-pointer d-inline-flex text-white"
                                        onClick={chooseShippingAddress}
                                        style={{ background: "#333", padding: "2px 7px", borderRadius: 5 }}>
                                        Use different address
                                    </p>
                                    {
                                        currentUser ? (
                                            <p
                                                className="different st-fs-13 cursor-pointer d-inline-flex text-white ms-2 ms-lg-3"
                                                onClick={handleAddressesModalOpen}
                                                style={{ background: "#333", padding: "2px 7px", borderRadius: 5 }}>
                                                {/* Use your default billing address */}
                                                Choose from your addresses
                                            </p>
                                        ) : null
                                    }
                                </div>
                            )
                        }

                        {/* radio */}
                        <label className="shipping-method-label d-block cursor-pointer">
                            <input type="radio"
                                value="credit-card"
                                className="d-none"
                                checked={formik.values.paymentMethod === "credit-card"}
                                onChange={ev => handleShippingMethodChange(ev, "Credit or debit card, Free")}
                            />
                            <span className="main d-flex align-items-center">
                                <span className="round d-flex align-items-center justify-content-center"></span>
                                <span className="text d-flex align-items-center media-body ps-3">
                                    <div className="lt">
                                        <span className="d-block head st-fw-600">Credit or debit card</span>
                                    </div>
                                    <div className="rt ms-auto ps-2">
                                        <div className="payment-methods d-flex flex-wrap">
                                            {
                                                paymentMethodsImages?.length ? paymentMethodsImages.map((item, index) => (
                                                    <div className="mr-2 my-1" key={index}>
                                                        <img src={item} alt="" width="50" />
                                                    </div>
                                                )) : null
                                            }
                                        </div>
                                    </div>
                                </span>
                            </span>
                        </label>
                        <button ref={submitBtnRef} className="btn d-none" type="submit">Suhmit</button>
                    </form>

                    {/* form credit card */}
                    <div className="form-credit-card">
                        <div className="inner">
                            <div className="top-sec w-100 d-flex mb-3">
                                <p className="text mb-0">Secure payment form</p>
                                <div className="icon ms-auto">
                                    <BiLock fontSize={23} color={"#333"} />
                                </div>
                            </div>

                            <div className="stripe-form">
                                {/* <StripePayment
                                    stripeToken={stripeToken}
                                    setStripeToken={setStripeToken}

                                    submitBtnRef={submitBtnRef}
                                /> */}
                                <PaymentForm
                                    submitBtnRef={submitBtnRef}

                                    formik={formik}
                                />
                            </div>
                        </div>
                    </div>

                    {
                        /* LOADING */
                        sectionLoading ? (
                            <div className="section-loading position-absolute align-items-center d-flex h-100 justify-content-center section-loading w-100" style={{ top: 0, left: 0, background: "rgba(255,255,255,0.5)" }}>
                                <Spinner animation="border" />
                            </div>
                        ) : null
                    }
                </div>
            </div>
        </div>
    )
}


const getDataFromStore = (state) => {
    return {
        currentUser: state.auth.currentUser,
    };
};

export default connect(getDataFromStore, null)(OptionCreditCard);